export default "__VITE_ASSET__D$_B2ybx__"